import { render, staticRenderFns } from "./sight2Scores.vue?vue&type=template&id=7c76cd23&scoped=true&"
import script from "./sight2Scores.vue?vue&type=script&lang=js&"
export * from "./sight2Scores.vue?vue&type=script&lang=js&"
import style0 from "./sight2Scores.vue?vue&type=style&index=0&id=7c76cd23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c76cd23",
  null
  
)

export default component.exports